import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import ShowXrated from './showXRated.vue';
export default {
  name: 'IntroAvatarViewer',
  components: {
    ShowXrated: ShowXrated
    // ButtonBasic,
    // ToggleComponent,
  },
  mounted: function mounted() {
    console.log('<<<<<<<<< IntroAvatarViewer mounted >>>>>>>>>');
    // this.$store.commit('startIntroPage', 'Voice');
    // this.$store.commit('stopIntroPage', 'AvatarViewer');
  },
  computed: {
    avatarStyle: function avatarStyle() {
      return {
        backgroundImage: "url(".concat(this.getImage(), ")"),
        height: '60vh',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        margin: '0 auto',
        maxWidth: '508px',
        marginTop: '58px',
        maxHeight: '659px',
        borderRadius: '25px',
        boxShadow: '2px 2px 4px rgba(0,0,0,0.3)'
      };
    }
  },
  methods: {
    getImage: function getImage() {
      var avatar = this.$store.state.selectedGalleryAvatar;
      if (avatar.animated) {
        return "assets/avatar/".concat(avatar.name.toLowerCase(), "/animations/").concat(avatar.name.toLowerCase(), ".webp");
      }
      if (this.$store.state.introShowAsXRated) {
        return avatar.nudes;
      } else {
        return avatar.image;
      }
    },
    useAvatar: function useAvatar() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var avatarName;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // add the avatar as the selected avatar
              avatarName = _this.$store.state.selectedGalleryAvatar.name.toLowerCase();
              _this.$store.commit('updateAvatar', avatarName);
              _context.next = 4;
              return _this.$store.dispatch("saveProfileToDB");
            case 4:
              //if we are just saving a single setting 
              if (_this.$store.state.singleIntroSave === true || _this.$store.state.singleIntroSave === 'true') {
                _this.$store.commit('updatePreventIntroExperience', false);
                // this.$store.dispatch("saveProfileToDB", 'avatar');
                _this.$store.commit('updateSingleIntroSave', false);
                _this.$store.commit('stopIntroPage', 'AvatarViewer');
              } else {
                _this.$store.commit('startIntroPage', 'Voice');
                _this.$store.commit('stopIntroPage', 'AvatarViewer');
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    backButton: function backButton() {
      this.$store.commit('startIntroPage', 'Gallery');
      this.$store.commit('stopIntroPage', 'AvatarViewer');
    }
  },
  setup: function setup() {},
  data: function data() {
    return {};
  }
};